export default {
  namespaced: true,
  state () {
    return {
      auth: null
    }
  },
  getters: {
    auth (state) {
      return state.auth
    }
  },
  mutations: {
    auth (state, payload) {
      state.auth = payload
    }
  },
  actions: {
    auth ({commit}, payload) {
      commit('auth', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Auth.js